// src/components/Pagination.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function Pagination({ currentPage, totalPages, language }) {
  // Crea el link para cada página
  const createPageLink = (page) => {
    // Ej: "/en/blog" si language !== 'es', sino "/blog"
    const basePath = language !== 'es' ? `/${language}/blog` : '/blog';

    // Para forzar el formato /blog/page/2/
    if (page > 1) {
      return `${basePath}/page/${page}/`;
    }
    return `${basePath}/`;
  };

  // Generamos un array con los números de página
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <ul className="cs_pagination_box">
      {/* Botón Anterior */}
      <li>
        {currentPage === 1 ? (
          <button className="cs_pagination_arrow cs_center" disabled>
            &lt;
          </button>
        ) : (
          <Link to={createPageLink(currentPage - 1)}>
            <button className="cs_pagination_arrow cs_center">
              &lt;
            </button>
          </Link>
        )}
      </li>

      {/* Botones con números de página */}
      {pageNumbers.map((page) => (
        <li key={page}>
          {currentPage === page ? (
            <button className="cs_pagination_item cs_center active">
              {page}
            </button>
          ) : (
            <Link to={createPageLink(page)}>
              <button className="cs_pagination_item cs_center">
                {page}
              </button>
            </Link>
          )}
        </li>
      ))}

      {/* Botón Siguiente */}
      <li>
        {currentPage === totalPages ? (
          <button className="cs_pagination_arrow cs_center" disabled>
            &gt;
          </button>
        ) : (
          <Link to={createPageLink(currentPage + 1)}>
            <button className="cs_pagination_arrow cs_center">
              &gt;
            </button>
          </Link>
        )}
      </li>
    </ul>
  );
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  language: PropTypes.string.isRequired,
};
